import React from "react";
import FooterThree from "../../common/Footer/FooterThree";
import Menu from "../../common/Menu/Menu";
import MobileDetailsBanner from "./MobileDetailsBanner";
import MobileDetailsSingle from "./MobileDetailsSingle";

const MobileDetails = () => {
  return (
    <>
      <Menu header_style_2={true} />
      <MobileDetailsBanner />
      <MobileDetailsSingle />
      <FooterThree />
    </>
  );
};

export default MobileDetails;
